<script lang="ts">
import { defineComponent, PropType, toRef } from 'vue'
import InputLeadFormWrapper from '@/components/lead/InputLeadFormWrapper.vue'
import SelectorDefault from '@/components/form/SelectorDefault.vue'
import { formDefaultProps, formPartial } from '@/models/formPartial'

export default defineComponent({
  name: 'SelectorForm',

  components: {
    InputLeadFormWrapper,
    SelectorDefault,
  },

  props: {
    /**
     * 初期選択状態が bind される value
     */
    modelValue: {
      type: [String, Number, Boolean],
      required: true,
    },

    /**
     * 選択肢の項目情報
     */
    items: {
      type: Array as PropType<SelectorOption[]>,
      required: true,
    },

    /**
     * <option> の末尾に付与される単位
     * 任意プロパティ
     *
     * @example unit="個" => <option>1個</option>
     */
    unit: {
      type: String,
      default: '',
    },

    /**
     * プレースホルダー用ラベル
     * 任意プロパティ
     */
    defaultSelectorLabel: {
      type: String,
      default: '',
    },

    /**
     * プレースホルダー用の値
     * 任意プロパティ
     */
    defaultSelectorValue: {
      type: [String, Number],
      default: null,
    },

    ...formDefaultProps,
  },

  emits: ['update:modelValue'],

  setup(props) {
    const { hasError } = formPartial(props.name, toRef(props, 'validationScheme'))

    return {
      // computed
      hasError,
    }
  }
})
</script>

<template>
  <InputLeadFormWrapper
    :model-value="modelValue"
    :header="header"
    :description="description"
    :namespace="namespace"
    :name="name"
    :is-disabled="isDisabled"
    :validation-scheme="validationScheme"
    is-select-type>
    <SelectorDefault
      :model-value="modelValue"
      :name="name"
      :items="items"
      :unit="unit"
      :is-disabled="isDisabled"
      :is-error="hasError"
      :default-selector-label="defaultSelectorLabel"
      :default-selector-value="defaultSelectorValue"
      @update:model-value="$emit('update:modelValue', $event)" />
  </InputLeadFormWrapper>
</template>
